import React from 'react';
import { CadenceCalendarArrow as Arrow } from '../../Style'

export const CadenceCalendarArrow = () => {
    return (
        <Arrow width="16" height="7" viewBox="0 0 16 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.0691 2.22863V0.76656C11.0691 0.427529 11.2365 0.194444 11.5713 0.0673077C11.9061 -0.0598291 12.1963 -0.00685541 12.4418 0.226229L15.3213 2.95967C15.4329 3.06562 15.4999 3.18216 15.5222 3.30929C15.5668 3.43643 15.5668 3.56357 15.5222 3.69071C15.4999 3.81784 15.4329 3.93438 15.3213 4.04033L12.4418 6.77377C12.1963 7.00686 11.9061 7.05983 11.5713 6.93269C11.2365 6.80556 11.0691 6.57247 11.0691 6.23344V4.77137H0.95745C0.689593 4.77137 0.555664 4.64423 0.555664 4.38996V2.61004C0.555664 2.35577 0.689593 2.22863 0.95745 2.22863H11.0691Z" fill="#1E4620" />
        </Arrow>
    )
}